// extracted by mini-css-extract-plugin
module.exports = {"logo":"style__logo__51jx3","wrapper":"style__wrapper__Lout5","trigger":"style__trigger__eev9+"};